import { render, staticRenderFns } from "./CrewLocationFields.vue?vue&type=template&id=384cafc2"
import script from "./CrewLocationFields.vue?vue&type=script&lang=js"
export * from "./CrewLocationFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports